"use strict";

$(document).ready(function () {

    /**
     * Tooltip
     * Doc: https://atomiks.github.io/tippyjs/
     */

    tippy('[data-tooltip]', {
        content(reference) {
            const id = reference.getAttribute('data-tooltip');
            const template = document.getElementById(id);
            return template.innerHTML;
        },
        allowHTML: true,
        theme: 'megaplast',
        arrow: false,
        placement: 'bottom-start',
        maxWidth: 280,
        hideOnClick: true,
    });


    /**
     * FancyBox 3
     * Docs: http://fancyapps.com/fancybox/3/docs/
     */

    $('[data-fancybox], [href^="#modal"]').fancybox({
        buttons: [
            'close',
        ],
        touch: false,
    });


    /**
     * Моб. меню
     */
    const mobileBlock = $('.site-header__mobile');
    const menu = $('.site-header__mobile-menu');
    const menuBg = $('.bg-mobile');

    $("[data-toggle-menu]").addClass('loaded');
    var x = 0;
    var isInitial = 0;
    function animateMenuSwitcher() {
        if ($(window).width() <= 991 && !document.hidden || !isInitial) {
            x++;
            if (x > 2) {
                x = 0;
            }
            anime({
                targets: "[data-toggle-menu] .phone",
                translateX: [100 + -50 * x, 50 + -50 * x],
                duration: 1500 * (x !== 0) * isInitial,
                easing: 'easeInOutExpo'
            });
            anime({
                targets: "[data-toggle-menu] .message",
                translateX: [100 + -50 * ((x + 2) % 3), 50 + -50 * ((x + 2) % 3)],
                duration: 1500 * (x !== 1) * isInitial,
                easing: 'easeInOutExpo'
            });
            anime({
                targets: "[data-toggle-menu] .email",
                translateX: [100 + -50 * ((x + 1) % 3), 50 + -50 * ((x + 1) % 3)],
                duration: 1500 * (x !== 2) * isInitial,
                easing: 'easeInOutExpo'
            });
        }
        setTimeout(function() {
            animateMenuSwitcher();
        }, isInitial ? 3000 : 1000);
        isInitial = 1;
    }
    animateMenuSwitcher();

    $("[data-toggle-menu]").click(function () {
      mobileBlock.toggleClass('site-header__mobile--opened');
      menu.stop(true, true).fadeToggle(200).toggleClass('site-header__mobile-menu--opened');
      menuBg.stop(true, true).fadeToggle(200);
    });

    menuBg.on('click', function () {
      mobileBlock.removeClass('site-header__mobile--opened');
      menu.stop(true, true).fadeOut(200).removeClass('site-header__mobile-menu--opened');
      menuBg.stop(true, true).fadeOut(200);
    });


    $("[ data-guarantee]").on('click', function () {
      const element = document.querySelector('#guarantee');

      element.scrollIntoView({ behavior: 'smooth', block: 'start'});
    });

    /**
     * Слайдеры
     */

    /*
    $('.welcome').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        dotsClass: 'welcome__dots',
    });*/

    $('.projects-block__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<button class="projects-block__arrow slick-prev"></button>',
      nextArrow: '<button class="projects-block__arrow slick-next"></button>',
    })

    $('.reviews__list').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<button class="reviews__arrow slick-prev"></button>',
      nextArrow: '<button class="reviews__arrow slick-next"></button>',
      dots: false,
      dotsClass: 'reviews__dots',
      responsive: [
        {
          breakpoint: 1460,
          settings: {
            slidesToShow: 1,
            adaptiveHeight: true,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            adaptiveHeight: true,
            arrows: false,
            dots: true,
          }
        },
      ]
    });

    $('.house__slider-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button class="house__slider-arrow slick-prev"></button>',
        nextArrow: '<button class="house__slider-arrow slick-next"></button>',
        dots: true,
        dotsClass: 'house__slider-dots',
    });

    $('.slider__list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button class="slider__arrow slick-prev"></button>',
        nextArrow: '<button class="slider__arrow slick-next"></button>',
        dots: false,
    });

    $('.montage__slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button class="montage__slider-arrow slick-prev"></button>',
        nextArrow: '<button class="montage__slider-arrow slick-next"></button>',
        dots: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.team__list').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button class="team__arrow slick-prev"></button>',
        nextArrow: '<button class="team__arrow slick-next"></button>',
        dots: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },{
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },{
                breakpoint: 461,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });


    /**
     * Подсказки
     */

    $('.tooltip__toggle').click(function () {
        $(this).parent('.tooltip').toggleClass('tooltip_open');
    });


    /**
     * Цены
     */

    $('.product__select-head').click(function () {
        $(this).parent('.product__select').toggleClass('product__select_open');
    });

    $('.product__select-item').click(function () {
        let size = $(this).text();
        let cost = $(this).data('cost');
        let product = $(this).parents('.product__item');
        let parent = $(this).parents('.product__select');
        parent.removeClass('product__select_open');
        $(this).addClass('product__select-item_active').siblings('.product__select-item').removeClass('product__select-item_active');
        parent.find('.product__select-head').text(size);
        product.find('.product__cost').text(cost);
    });


    /**
     * Экономия
     */

    $("#savingSlider").slider({
        range: "min",
        min: 20,
        max: 500,
        step: 1,
        value: 124,
        slide: function( event, ui ) {
            $("#areaValue").text(ui.value);
            let type = $('#savingType').val();
            let area = ui.value;
            $('#savingSum').text(area * type);
        }
    });

    $("#areaValue").text($("#savingSlider").slider("value"));

    function saving() {
        let type = $('#savingType').val();
        let area = $("#savingSlider").slider("value");
        $('#savingSum').text(area * type);
    }

    saving();

    $('#savingType').change(function () {
        saving();
    });


    /**
     * Вкладки
     */

    $('.tabs-nav').each(function () {
        $(this).find('.tabs-nav__item').each(function (i) {
            $(this).on('click', function () {
                $(this).addClass('tabs-nav__item_active').siblings().removeClass('tabs-nav__item_active')
                    .closest('.tabs').find('.tabs-content').removeClass('tabs-content_active').eq(i).addClass('tabs-content_active');
            });
        });
    });


    /**
     * Калькулятор цен услуг
     */

    $('.price__calc-control').on('keyup', function(){
        $(this).val($(this).val().replace (/\D/, ''));
    });

    $('#btnCalc').click(function () {
        let widthCalc = Number($('#widthCalc').val()) / 1000;
        let heightCalc = Number($('#heightCalc').val()) / 1000;
        let square = widthCalc * heightCalc;
        let squareNum = +square.toFixed(1);

        $('.price__table-td_type').text('за ' + squareNum + ' м²');

        $('.price__table-td_cost').each(function(i, el){
            let cost = $(this).data('price');
            let price = cost * square;
            $(this).text(price.toLocaleString()+' ₽');
        });

    });


});
